import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { EdTabsHeaderOption } from '@/models/ed-tabs-header-option.model';

@Component({})
class EdTabsHeader extends Vue {
  
  @Prop() readonly options: EdTabsHeaderOption[];
  @Prop({ default: true }) readonly useLink;
  @Prop({ default: false }) readonly disabled;

  get menu():EdTabsHeaderOption[] {
    if(this.useLink) {
      return this.options.map((o, i) => {
        return {
          ...o,
          active: this.$route.path.includes(o.name),
        }
      });
    } else return this.options
  }

  changeTab(tabId) {
    this.$emit('changeMenuTab', tabId)
  }

  mounted() {
    document.getElementById('ed-tabs-header').style.gridTemplateColumns = `repeat(${this.options.length}, 1fr)`
  }

}

export default Vue.component('ed-tabs-header', EdTabsHeader);